import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import {
  emptyStateIconWrap,
} from "@/components/Templates/Page/ListPage.styles";

export { emptyStateIconWrap };

export const pageStack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(2), md: theme.spacing(2.75) },
});

export const desktopHeader: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
};

export const infoNote: SxProps<Theme> = (theme) => ({
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "text.secondary",
  bgcolor: alpha(theme.palette.text.primary, 0.04),
  borderRadius: 2,
  px: 2,
  py: 1.5,
  lineHeight: 1.8,
});

export const mobileHeader: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  gap: 0.375,
};

export const mobileTitle: SxProps<Theme> = {
  fontSize: "1.1875rem",
  fontWeight: 700,
  lineHeight: 1.2,
};

export const mobileSubtitle: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  lineHeight: 1.5,
};

export const shopList: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(1.5), md: theme.spacing(1.75) },
});

export const populatedContent: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(2), md: theme.spacing(2.75) },
});

export const loadingWrap: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  py: 6,
};

export const desktopEmptyStateCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: theme.shadows[3],
  p: theme.spacing(8.75, 3),
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.75,
  textAlign: "center",
});

export const desktopEmptyTitle: SxProps<Theme> = {
  fontSize: "1.25rem",
  fontWeight: 700,
};

export const desktopEmptyDescription: SxProps<Theme> = {
  fontSize: "0.84375rem",
  color: "text.secondary",
  maxWidth: 380,
  lineHeight: 1.8,
};

export const desktopEmptyIconWrap: SxProps<Theme> = (theme) => ({
  width: 110,
  height: 110,
  borderRadius: 3.5,
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
});

export const emptyActionWrap: SxProps<Theme> = {
  mt: 1.75,
};

export const mobileEmptyState: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  textAlign: "center",
  py: 7.5,
  px: 1.5,
};

export const mobileEmptyIconWrap: SxProps<Theme> = (theme) => ({
  width: 96,
  height: 96,
  borderRadius: 3.25,
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
});

export const mobileEmptyTitle: SxProps<Theme> = {
  fontSize: "1.03125rem",
  fontWeight: 700,
  lineHeight: 1.3,
};

export const mobileEmptyDescription: SxProps<Theme> = {
  maxWidth: 260,
  lineHeight: 1.8,
  fontSize: "0.78125rem",
  color: "text.secondary",
};

export const mobileEmptyButton: SxProps<Theme> = (theme) => ({
  minWidth: 0,
  width: "auto",
  height: 46,
  px: 2.75,
  mt: 1.75,
  borderRadius: 1.5,
  fontSize: "0.875rem",
  fontWeight: 700,
  boxShadow: `0 10px 20px ${alpha(theme.palette.primary.dark, 0.25)}`,
});

export const howItWorksTitle: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 800,
  color: "text.primary",
  mb: 0.5,
};

export const howItWorksLine: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  lineHeight: 1.9,
};
